module.exports = __webpack_public_path__ + "img/6.9d83bb7c.jpg";